import { render } from "./PriceQuotationSheetForm.vue?vue&type=template&id=13fb7443&scoped=true&ts=true"
import script from "./PriceQuotationSheetForm.vue?vue&type=script&lang=ts"
export * from "./PriceQuotationSheetForm.vue?vue&type=script&lang=ts"

import "./PriceQuotationSheetForm.vue?vue&type=style&index=0&id=13fb7443&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fb7443"]])

export default __exports__